import { useCallback } from 'react';
import { hotjar } from 'react-hotjar';

import { SiteConfigManager } from '@atlas/core';

const useHotjar = () => {
  const hotjarConfig = SiteConfigManager.getConfig('config.config.general.hotjar');

  const initHotjar = useCallback(() => {
    if (hotjarConfig?.id && hotjarConfig?.version) {
      hotjar.initialize({
        id: hotjarConfig.id,
        sv: hotjarConfig.version,
      });
    }
  }, [hotjarConfig]);

  return { initHotjar };
};

export default useHotjar;
